import React from 'react';

const CBSpin = ({
  spinning = true,
  tip, // Text displayed below the spinner
  size = 'default', // 'small', 'default', 'large' -> controls height
  children, // Content to overlay spinner on
  className = '', // Class for the wrapper
  indicator, // Custom indicator ReactNode
}) => {
  let heightClass = 'h-2'; // default height
  if (size === 'small') {
    heightClass = 'h-1';
  }
  if (size === 'large') {
    heightClass = 'h-3';
  }

  // Custom horizontal indeterminate progress bar using a moving gradient
  const customProgressBar = (
    <>
      {/* Define the animation using a style tag */}
      <style>
        {`
          @keyframes progress-gradient {
            0% { background-position: -200% 0; }
            100% { background-position: 200% 0; }
          }
          .animate-progress-gradient {
            background-size: 200% 100%;
            /* Using hex for darkblue_highlight */
            background-image: linear-gradient(to right, transparent 0%, #00447c 50%, transparent 100%);
            animation: progress-gradient 1.5s linear infinite;
          }
        `}
      </style>
      <div
        className={`relative w-full overflow-hidden rounded ${heightClass} bg-gray-200`}
        role="progressbar"
        aria-busy={spinning}
        aria-live="polite"
        aria-label={tip || 'Loading'} // Add aria-label
      >
        {/* The animating gradient element */}
        <div className={`absolute top-0 left-0 h-full w-full rounded animate-progress-gradient`}></div>
        <span className="sr-only">Loading...</span> {/* Accessibility */}
      </div>
    </>
  );

  const spinnerIndicator = indicator || customProgressBar;

  // Container for the spinner and tip when no children are present
  const spinnerContainer = (
    <div className={`flex w-full flex-col items-center justify-center ${className}`}>
      {/* Constrain width of the progress bar itself */}
      <div className="w-3/4 max-w-xs">
        {spinnerIndicator}
      </div>
      {tip && <span className="mt-2 text-sm text-gray-600">{tip}</span>}
    </div>
  );

  // Container for the spinner and tip when overlaying children
  const overlayContainer = (
    <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-white bg-opacity-75">
       {/* Constrain width of the progress bar itself */}
      <div className="w-3/4 max-w-xs">
        {spinnerIndicator}
      </div>
      {tip && <span className="mt-2 text-sm text-gray-600">{tip}</span>}
    </div>
  );

  if (!children) {
    // Simple progress bar display
    return spinning ? spinnerContainer : null;
  }

  // Progress bar as overlay
  return (
    <div className={`relative ${className}`}>
      {spinning && overlayContainer}
      <div className={spinning ? 'opacity-50 pointer-events-none' : ''}>
        {children}
      </div>
    </div>
  );
};

export { CBSpin };